// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__0HGOb","position-center":"styles_position-center__8YF0o","position-left":"styles_position-left__X9PNI","position-right":"styles_position-right__7Vx-+"};